/**
 * Created by intellicar-rinas on 4/6/18.
 */
const messages = [
    {
        msgs: ['getting report', 'fetching report'],
        tags:['get', 'show route', 'show driving'],
    },
    {
        msgs: ['Searching for *', 'Im on it', 'working on it'],
        tags:['search', 'give', 'show'],
    },
    {
        msgs: ['Here we go', 'we are on * now', 'on *'],
        tags:['goto', 'go to'],
    },
];

const defaultMessages = [
    'Working on it',
    'Im on it'
];

export default (cmd, params)=> {
    let index;
    for(let idx in messages) {
        for(let jdx in messages[idx].tags) {
            if(cmd.indexOf(messages[idx].tags[jdx]) !== -1) {
                index = Math.floor(messages[idx].msgs.length * Math.random());
                return messages[idx].msgs[index].replace('*', params[0]);
            }
        }
    }
    index = Math.floor(defaultMessages.length * Math.random());
    return defaultMessages[index];
}